import React from 'react';
import { TabletAndDesktop, Image, AspectRatio } from '@stockx/ui';
import { SwitcherLink } from '@app/router';
import { useBannerCollage } from '../../hooks';
import { CollageBannersWrapper } from '../../BannerCollage.styles';
import { CollageComponentProps } from '../../types';

const DesktopBannerCollage = ({
  collage,
  displayType,
  handleTrackingEvent,
  handleTrackingImpression,
}: CollageComponentProps) => {
  const isLargeFirst = displayType === 'LEADING_WITH_LARGE';
  const { bannerCollage } = useBannerCollage(collage);

  const {
    large: {
      image: { alt: largeAlt, url: largeImageUrl },
      link: { title: largeTitle, url: largeLinkUrl, urlType: largeUrlType },
      trackingEvent: largeTrackingEvent,
    },
    small: {
      image: { alt: smallAlt, url: smallImageUrl },
      link: { title: smallTitle, url: smallLinkUrl, urlType: smallUrlType },
      trackingEvent: smallTrackingEvent,
    },
  } = bannerCollage;

  return (
    <TabletAndDesktop>
      <CollageBannersWrapper flexDir={isLargeFirst ? 'row' : 'row-reverse'}>
        <AspectRatio ratio={809 / 438} width="64%">
          <SwitcherLink
            as={largeUrlType}
            title={largeTitle}
            to={largeLinkUrl}
            onClick={() =>
              handleTrackingEvent({
                bannerSize: 'Large',
                destination: largeUrlType,
                trackingEvent: largeTrackingEvent,
                URL: largeLinkUrl,
              })
            }
          >
            <Image
              alt={largeAlt}
              src={`${largeImageUrl}?format=jpg&auto=webp&height=438`}
              width="100%"
              height="100%"
              onLoad={() => handleTrackingImpression(largeTrackingEvent)}
              loading="lazy"
            />
          </SwitcherLink>
        </AspectRatio>
        <AspectRatio ratio={215 / 219} width="34%">
          <SwitcherLink
            as={smallUrlType}
            title={smallTitle}
            to={smallLinkUrl}
            onClick={() =>
              handleTrackingEvent({
                bannerSize: 'Small',
                destination: smallUrlType,
                trackingEvent: smallTrackingEvent,
                URL: smallLinkUrl,
              })
            }
          >
            <Image
              alt={smallAlt}
              src={`${smallImageUrl}?format=jpg&auto=webp&height=438`}
              width="100%"
              height="100%"
              onLoad={() => handleTrackingImpression(smallTrackingEvent)}
              loading="lazy"
            />
          </SwitcherLink>
        </AspectRatio>
      </CollageBannersWrapper>
    </TabletAndDesktop>
  );
};

export default DesktopBannerCollage;
